import { StyleSheet } from 'react-native'
export default StyleSheet.create({
    statusBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 12,
    },
    statusText: {
        fontSize: 12,
        fontWeight: '600',
        color: 'white',
        marginLeft: 4,
    },
})
